import script from "./DashboardItem.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardItem.vue?vue&type=script&setup=true&lang=js"

import "./DashboardItem.vue?vue&type=style&index=0&id=30acc12c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30acc12c"]])

export default __exports__